import { render, staticRenderFns } from "./Ilmoittautuminen.vue?vue&type=template&id=c22cb630&scoped=true"
import script from "./Ilmoittautuminen.vue?vue&type=script&lang=js"
export * from "./Ilmoittautuminen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22cb630",
  null
  
)

export default component.exports